import Vue from 'vue'
import Router from 'vue-router'
import pageRouters from './pageRouters'
import PageIndex from '../pages'

Vue.use(Router)

const routes = [
  {
    path: '',
    component: PageIndex,
    children: [
      ...pageRouters
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: '/home/',
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (!to.matched || to.matched.length === 0) {
    next('/')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js